<template>
  <div>
    <el-dialog
      class="setting-dialog"
      title="提现设置"
      width="600px"
      v-on="$listeners"
      v-bind="$attrs"
      @close="handleClose"
    >
      <form>
        提现金额最低
        <zt-input
          width="80px"
          type="number"
          v-model="settingParams.withdraw_min_amount"
        />元；总金额需为
        <zt-input
          width="80px"
          type="number"
          v-model="settingParams.withdraw_base_amount"
        />的整数倍
        <div class="help mb32 mt24">
          最低金额不低于1元，且金额最低倍数需整数
        </div>
        <div>
          <zt-button
            width="140px"
            class="mb24"
            type="primary"
            size="medium"
            native-type="submit"
            @click.enter.exact="onSettingWithdraw"
            >确定</zt-button
          >
        </div>
      </form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {  taoke_cms_withdraw_set } from '@/api/finance';

export default {
  data() {
    return {
      settingParams: {
        withdraw_min_amount: '',
        withdraw_base_amount: '',
      },
    }
  },
  computed: {
    ...mapGetters(['cms_info']),
  },
  watch: {
    cms_info: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.settingParams.withdraw_min_amount = val.withdraw_min_amount;
          this.settingParams.withdraw_base_amount = val.withdraw_base_amount;
        }
      },
    },
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 设置提现
    async onSettingWithdraw() {
      let { withdraw_min_amount, withdraw_base_amount } = this.settingParams;

      if (withdraw_min_amount - 0 < 1) {
        return this.$message.error('最低金额不低于1元');
      } else if ((withdraw_base_amount - 0) % 1 != 0) {
        return this.$message.error('金额最低倍数需整数');
      }

      const { data } = await taoke_cms_withdraw_set(this.settingParams);
      if (data.error_code != 0) {
        this.$message.error(data.error_message);
      } else {
        this.$message.success('设置成功');
        this.$store.dispatch('GetCmsInfo');
        this.handleClose()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-dialog {
  /deep/ .el-dialog__body {
    text-align: center;
  }

  .help {
    color: #c1c9d2;
    font-size: 12px;
    margin-top: 6px;
    line-height: 17px;
  }
}
</style>